import React from "react";

import { useTranslation } from "react-i18next";
import { AuthingButton } from "../../../components/AuthingButton";
import { DownRcode } from "../../../components/DownRcode";
import { tryNow } from "../../../utils";
import "./styles.less";

export const AuthorizationBanner = (props) => {
  const { t } = useTranslation();

  return (
    <div>
      <section className="authority-banner">
        <div className="identity-banner-container basic-column">
          <div>
            <div className="banner-title">{t("authority.banner.title")}</div>
            <div className="subtitle">{t("authority.banner.subtitle")}</div>
            <AuthingButton
              style={{ marginRight: 24, fontSize: 18 }}
              mode="dark"
              onClick={tryNow}
            >
              {t("common.button.try-now")}
            </AuthingButton>

            <AuthingButton
              style={{ fontSize: 18 }}
              mode="light"
              onClick={() => {
                // setVisible(true);
                window.open(
                  "https://www.authing.cn/authingform?fromTag=权限管理"
                );
              }}
            >
              {t("common.button.consult")}
            </AuthingButton>
          </div>
          <div className="tenant-banner-img">
            <img
              src={`//files.authing.co/authing-website/${t(
                "authority.banner.img"
              )}`}
              alt="authing"
            />
          </div>
        </div>
      </section>
      <div className="tenant-banner-data-warp">
        <div className="identity-banner-data basic-column">
          <div className="data-item">
            <div className="data-item-number">
              <span>85</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("authority.banner.data1")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>91</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("authority.banner.data2")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>79</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("authority.banner.data3")}</div>
          </div>
          <div className="data-item">
            <div className="data-item-number">
              <span>97</span>
              <span className="data-item-character">%</span>
            </div>
            <div>{t("authority.banner.data4")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
